module.exports = __webpack_public_path__ + "img/中国建设银行_logo.63c6fb88.png";